export default __webpack_public_path__ + "static/media/ndimofor-aretas-portrait.61287d69.png";